export default {
  ARTICLE: {
    PAGE_VIEW: 'article.page_view',
  },
  CART: {
    ITEM: {
      ADD: 'cart.item.add',
      REMOVE: 'cart.item.remove',
    },
    LOADED: 'cart.loaded',
  },
  CATALOG: {
    PAGE_VIEW: 'catalog.page_view',
  },
  CHECKOUT: {
    STEP_LOAD: 'checkout.step_load',
    STEP_OPTION: 'checkout.step_option',
    STEP_VIEW_CART: 'checkout.step_view_cart',
  },
  FILE: {
    DOWNLOAD: 'file.download',
  },
  FORM: {
    SUBMIT: 'form.submit',
  },
  NEWSLETTER: {
    SUBSCRIBED: 'newsletter.subscribed',
  },
  NOT_FOUND: {
    PAGE_VIEW: 'not_found.page_view',
  },
  PRODUCT: {
    CLICK: 'product.click',
    IMPRESSION: 'product.impression',
    PAGE_VIEW: 'product.page_view',
    SELECT_ITEM: 'product.select_item',
  },
  PROMOTION: {
    CLICK: 'promotion.click',
    IMPRESSION: 'promotion.impression',
  },
  ORDER: {
    PLACED: 'order.placed',
  },
  SEARCH: {
    QUERY: 'search.query',
    RESULTS: 'search.results',
    PAGE_VIEW: 'search.page_view',
  },
  SITE: {
    PAGE_VIEW: 'site.page_view',
    SESSION_LOADED: 'site.session_loaded',
  },
  USER: {
    LOADED: 'user.loaded',
    REGISTERED: 'user.registered',
    LOGGED_IN: 'user.logged_in',
  },
}
